import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const AlignRight = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 24 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.5 6C20.7761 6 21 6.22386 21 6.5C21 6.77614 20.7761 7 20.5 7H3.5C3.22386 7 3 6.77614 3 6.5C3 6.22386 3.22386 6 3.5 6H20.5ZM21 12C21 11.7239 20.7761 11.5 20.5 11.5H3.5C3.22386 11.5 3 11.7239 3 12C3 12.2761 3.22386 12.5 3.5 12.5H20.5C20.7761 12.5 21 12.2761 21 12ZM21 17.5C21 17.2239 20.7761 17 20.5 17H11.5C11.2239 17 11 17.2239 11 17.5C11 17.7761 11.2239 18 11.5 18H20.5C20.7761 18 21 17.7761 21 17.5Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default AlignRight
